import { createSelector } from 'reselect';
import { keys } from '../../../constants/keys.esm.js';

function getFilter(selectedCategory, categories) {
  var _categories$find, _categories$find$fiel;
  if (!selectedCategory) {
    return undefined;
  }
  if (selectedCategory === keys.allFields) {
    return undefined;
  }
  return categories === null || categories === void 0 ? void 0 : (_categories$find = categories.find(function (c) {
    return c.label === selectedCategory;
  })) === null || _categories$find === void 0 ? void 0 : (_categories$find$fiel = _categories$find.fields) === null || _categories$find$fiel === void 0 ? void 0 : _categories$find$fiel.map(function (f) {
    return f.toString();
  });
}
var createFilterSelector = function createFilterSelector() {
  return createSelector(function (props) {
    return props.selectedCategory;
  }, function (props) {
    return props.categories;
  }, getFilter);
};

export { createFilterSelector };
//# sourceMappingURL=filter-selector.esm.js.map
